const dateViewTemplate = `
<input type="text"
       inputmode="numeric"
       pattern="[0-9]*"
       name="{{ctrl.name}}"
       id="{{ctrl.id}}"
       class="{{ctrl.class}}"
       ng-model="ctrl.model"
       ng-model-options="{ updateOn: 'blur', allowInvalid: true }"
       ng-required="ctrl.isRequired()"
       ng-disabled="ctrl.isDisabled()"
       pw-date-validator
       min-date="ctrl.minDate"
       allow-future-date="ctrl.allowFutureDate"
       pw-mask="**/**/****"
/>
`;
export default dateViewTemplate;
